import * as React from 'react';
import classnames from 'classnames';
import { SECTION_NOTIFICATION_DATA_HOOKS } from '../dataHooks';
import { classes } from '../SectionNotification.deprecated.st.css';
export class SectionNotificationIcon extends React.Component {
    render() {
        return (React.createElement("div", { className: classnames(classes.icon, this.props.className), "data-hook": SECTION_NOTIFICATION_DATA_HOOKS.icon, "aria-hidden": true }, this.props.icon));
    }
}
SectionNotificationIcon.displayName = 'SectionNotification.Icon';
//# sourceMappingURL=SectionNotificationIcon.js.map